<template>
  <div class="container mt-5 mb-5">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="card shadow-lg p-4">
          <h2 class="text-center mb-4 text-primary">
            <i class="fa fa-refresh me-2"></i>{{ $t("reset.title") }}
          </h2>

          <div v-if="successMessage" class="alert alert-success">
            <i class="fa fa-check-circle me-2"></i>{{ successMessage }}
          </div>
          <div v-if="errorMessage" class="alert alert-danger">
            <i class="fa fa-exclamation-circle me-2"></i>{{ errorMessage }}
          </div>

          <form @submit.prevent="confirmReset">
            <div class="mb-3">
              <label for="reset_code" class="form-label">
                <i class="fa fa-key me-2"></i>{{ $t("reset.codeLabel") }}
              </label>
              <input
                type="text"
                id="reset_code"
                class="form-control"
                v-model="reset_code"
                required
                :placeholder="$t('reset.codePlaceholder')"
              />
            </div>

            <div class="mb-3">
              <label for="new_password" class="form-label">
                <i class="fa fa-lock me-2"></i>{{ $t("reset.newPasswordLabel") }}
              </label>
              <input
                type="password"
                id="new_password"
                class="form-control"
                v-model="new_password"
                required
                :placeholder="$t('reset.newPasswordPlaceholder')"
              />
            </div>

            <button type="submit" class="btn btn-success w-100" :disabled="loading">
              <i class="fa fa-sync-alt me-2"></i>{{ loading ? $t("reset.loading") : $t("reset.button") }}
            </button>
          </form>

          <div class="text-center mt-3">
            <router-link to="/login" class="back-link">
              <i class="fa fa-arrow-left me-1"></i>{{ $t("reset.back") }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.card {
  border-radius: 10px;
  background: #ffffff;
  border: none;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
h2 {
  font-size: 1.8rem;
  font-weight: bold;
}
.form-control {
  border-radius: 8px;
  border: 1px solid #ccc;
  padding: 12px;
}
.form-control:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}
.btn-success {
  background-color: #28a745;
  border: none;
  padding: 12px;
  font-size: 1.1rem;
  border-radius: 8px;
  transition: background-color 0.3s;
}
.btn-success:hover {
  background-color: #218838;
}
.back-link {
  color: #007bff;
  font-weight: bold;
  text-decoration: none;
  transition: color 0.3s;
}
.back-link:hover {
  color: #0056b3;
}
.alert {
  font-size: 0.9rem;
  border-radius: 8px;
  padding: 10px;
  text-align: center;
}
</style>


<script>
import axios from "axios";

export default {
  name: "ResetPassword",
  data() {
    return {
      reset_code: "",
      new_password: "",
      successMessage: "",
      errorMessage: "",
      loading: false,
      email: localStorage.getItem("reset_email") || ""
    };
  },
  methods: {
    async confirmReset() {
      if (!this.reset_code || this.new_password.length < 6) {
        this.errorMessage = this.$t("reset.invalid");
        return;
      }

      this.successMessage = "";
      this.errorMessage = "";
      this.loading = true;

      try {
        await axios.post("https://api.feribot-eurobac.ro/client/api/reset-password/", {
          email: this.email,
          reset_code: this.reset_code.trim(),
          new_password: this.new_password.trim()
        });

        this.successMessage = this.$t("reset.success");
        this.loading = false;

        setTimeout(() => {
          this.$router.push("/login");
        }, 2000);
      } catch (error) {
        this.errorMessage = error.response?.data?.error || this.$t("reset.error");
        this.loading = false;
      }
    }
  }
};
</script>
